<template>
  <div>
      <combo-table :query="queryAPI" :columns="columns" :queryParams="queryParams"></combo-table>
  </div>
</template>

<script>
import ComboTable from '../../components/combo-table'
import Utils from "../../utils";
import API from "../../api";

export default {

  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    
    this.api = API.omsAPI[this.env]
  },

  components: {
    'combo-table': ComboTable
  },
  data(){
    return {
      columns: [
          {
            title: "项目编号",
            key: "id",
          },
          {
            title: "项目",
            key: "name",
          },
          {
            title: "描述",
            key: "description",
          },
          {
            title: "操作",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        console.info(params);
                        // params.row
                        this.toggleAddCleanStepModal(
                          true,
                          "editItemModal",
                          params.row,
                        );
                      }
                    }
                  },
                  "修改"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        console.info(params);
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        queryParams:{
        }
    }
  },
  methods:{
    queryAPI(params){
      return API.omsAPI[this.env].cleaner.cleanStepItemList(params,this.token)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/cleaner/test-normal-table.vue